export const actions = {
    PRINT: 'PRINT',
    CLEAR: 'CLEAR',
};
